import { defineComponent as _defineComponent } from 'vue'
import BaseCard from "@/components/base/BaseCard.vue";
import OfferMetricsTable from "./OfferMetricsTable.vue";
import { OfferSingle } from "@/services/offers/OfferSingle";

interface Props {
    offer: OfferSingle
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferCardTableMetrics',
  props: {
    offer: null
  },
  setup(__props: any) {

const props = __props as {
    offer: OfferSingle
}



return { __sfc: true,props, BaseCard, OfferMetricsTable }
}

})